module.exports = __webpack_public_path__ + "static/erica-3c2cd0fac319156ec560901625954e72.jpg";